<template>
  <div class="podcasts__container">
    <HeaderDropdown
      dropdown-id="podcasts"
      :left-offset="-100"
      :opened-dropdown-id="openedDropdownId"
      :trigger-text="$t('modules.navigation.podcasts')"
      @dropdownOpened="$emit('dropdownOpened', $event)"
    >
      <div class="podcasts__content-drop">
        <div class="podcasts__content-drop-links">
          <IconEntry
            icon-name="TrueCrime"
            :title="$t('modules.navigation.podcasts_dropdown.true_crime')"
            :href="$locatedLink('/podcast-hosting/true-crime/')"
          />
          <IconEntry icon-name="News" :title="$t('modules.navigation.podcasts_dropdown.news')" :href="$locatedLink('/podcast-hosting/news/')" />
          <IconEntry icon-name="Comedy" :title="$t('modules.navigation.podcasts_dropdown.comedy')" :href="$locatedLink('/podcast-hosting/comedy/')" />
          <IconEntry
            icon-name="SocietyAndCulture"
            :title="$t('modules.navigation.podcasts_dropdown.society_and_culture')"
            :href="$locatedLink('/podcast-hosting/society-culture/')"
          />
          <IconEntry
            icon-name="Business"
            :title="$t('modules.navigation.podcasts_dropdown.business')"
            :href="$locatedLink('/podcast-hosting/business/')"
          />
          <IconEntry
            icon-name="HealthAndFitness"
            :title="$t('modules.navigation.podcasts_dropdown.health_and_fitness')"
            :href="$locatedLink('/podcast-hosting/health-fitness/')"
          />
          <IconEntry
            icon-name="Education"
            :title="$t('modules.navigation.podcasts_dropdown.education')"
            :href="$locatedLink('/podcast-hosting/education/')"
          />
          <IconEntry
            icon-name="Technology"
            :title="$t('modules.navigation.podcasts_dropdown.technology')"
            :href="$locatedLink('/podcast-hosting/technology/')"
          />
          <IconEntry
            icon-name="PersonalJournal"
            :title="$t('modules.navigation.podcasts_dropdown.personal_journal')"
            :href="$locatedLink('/podcast-hosting/personal-journals/')"
          />
          <IconEntry icon-name="Sports" :title="$t('modules.navigation.podcasts_dropdown.sports')" :href="$locatedLink('/podcast-hosting/sports/')" />
          <IconEntry
            icon-name="Religion"
            :title="$t('modules.navigation.podcasts_dropdown.religion_spirituality')"
            :href="$locatedLink('/podcast-hosting/religion-spirituality/')"
          />
        </div>
        <DropdownFooter :text="$t('modules.navigation.podcasts_dropdown.all_podcasts')" :url="$locatedLink('/community/')" />
      </div>
    </HeaderDropdown>
  </div>
</template>

<script>
import IconEntry from '@/components/modules/header/items/IconEntry'
import HeaderDropdown from '@/components/modules/header/HeaderDropdown'
import DropdownFooter from '@/components/modules/header/items/DropdownFooter'

export default {
  components: {
    IconEntry,
    HeaderDropdown,
    DropdownFooter
  },

  props: {
    openedDropdownId: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.podcasts {
  &__content {
    &-drop {
      &-links {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: $gap;
        font-weight: 400;

        @include display-less(desktop) {
          grid-template-columns: 1fr;
          gap: 0;
        }
      }
    }
  }
}
</style>
